import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { updateMetaTags } from '@/utils/metaTags';

interface LanguageSelectorProps {
  currentPath?: string;
}

export const LanguageSelector = ({ currentPath = '' }: LanguageSelectorProps) => {
  const navigate = useNavigate();

  const handleLanguageChange = (lang: string) => {
    const basePath = '/coming-soon';
    const newPath = `/${lang}${basePath}`;
    updateMetaTags(lang);
    navigate(newPath);
  };

  const isSelected = (lang: string) => {
    return currentPath.includes(`/${lang}/`);
  };

  return (
    <div className="flex gap-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => handleLanguageChange('es')}
        className={`text-sm font-medium transition-colors ${
          isSelected('es') ? 'text-[#ea384c]' : 'hover:text-primary'
        }`}
      >
        ES
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => handleLanguageChange('ca')}
        className={`text-sm font-medium transition-colors ${
          isSelected('ca') ? 'text-[#ea384c]' : 'hover:text-primary'
        }`}
      >
        CA
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => handleLanguageChange('en')}
        className={`text-sm font-medium transition-colors ${
          isSelected('en') ? 'text-[#ea384c]' : 'hover:text-primary'
        }`}
      >
        EN
      </Button>
    </div>
  );
};